import { createFileRoute, notFound } from "@tanstack/react-router";

import { caseTemplatesQueries } from "@/api/resources/caseTemplates/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import CaseTemplatePage from "@/components/CaseTemplate/CaseTemplatePage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/knowledge-hub/case-templates/$case_template_id/")(
  {
    beforeLoad: () => {
      const breadcrumbs: BreadcrumbsContext[] = [
        {
          label: i18n.t("navigation.workspace"),
          icon: <Icon.WORKSPACE />,
          path: "/workspaces/$workspace_id",
        },
        {
          label: i18n.t("navigation.knowledge-hub-case-templates"),
          icon: <Icon.CASE_TEMPLATES />,
          path: "/workspaces/$workspace_id/knowledge-hub/case-templates",
        },
      ];
      return { breadcrumbs };
    },
    loader: async ({ context, params: { workspace_id, case_template_id } }) => {
      const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
      if (!currentWorkspace) throw notFound();

      const currentCaseTemplate = await context.queryClient.ensureQueryData(
        caseTemplatesQueries.byId(case_template_id),
      );
      if (!currentCaseTemplate) throw notFound();

      const breadcrumbs: BreadcrumbsContext[] = [{ label: currentCaseTemplate.name, icon: <Icon.CASE_TEMPLATE /> }];
      context.breadcrumbs.splice(2, 1, ...breadcrumbs);
    },
    component: CaseTemplatePage,
  },
);
